<template>
  <div class="pb-3">
    <v-radio-group
      v-model="body.luovutuskirjanTyyppi"
      label="Luovutuskirjan tyyppi"
      hide-details
      class="mb-5 mt-0"
    >
      <v-radio
        v-for="(n, index) in luovutuskirjanTyyppiOptions"
        :key="index"
        :label="n.text"
        :value="n.value"
        :disabled="!n.supported"
      />
    </v-radio-group>

    <template v-if="body.luovutusilmoitus">
      <v-radio-group
        v-if="kayttotarkoitusOptions.length && body.luovutusilmoitus"
        v-model="body.luovutusilmoitus.kayttotarkoitus"
        label="Käyttötarkoitus"
        hide-details
        class="mb-5"
      >
        <v-radio
          v-for="(n, index) in kayttotarkoitusOptions"
          :key="index"
          :label="n.text"
          :value="n.value"
          :disabled="!n.supported"
        />
      </v-radio-group>

      <v-radio-group
        v-if="rakennustiedotOptions.length"
        v-model="body.luovutusilmoitus.rakennustiedot"
        label="Rakennustiedot"
        hide-details
        class="mb-5"
      >
        <v-radio
          v-for="(n, index) in rakennustiedotOptions"
          :key="index"
          :label="n.text"
          :value="n.value"
          :disabled="!n.supported"
        />
      </v-radio-group>

      <v-radio-group
        v-if="kaavatiedotOptions.length"
        v-model="body.luovutusilmoitus.kaavatiedot"
        label="Kaavatiedot"
        hide-details
        class="mb-5"
      >
        <v-radio
          v-for="(n, index) in kaavatiedotOptions"
          :key="index"
          :label="n.text"
          :value="n.value"
          :disabled="!n.supported"
        />
      </v-radio-group>

      <v-checkbox
        v-if="kayttotarkoitusOptions.length"
        v-model="body.luovutusilmoitus.rantatontti"
        hide-details
        class="mb-5"
        label="Rantatontti"
      />

      <v-checkbox
        v-if="kayttotarkoitusOptions.length"
        v-model="body.luovutusilmoitus.sukulaisluovutus"
        hide-details
        class="mb-5"
        label="Sukulaisluovutus"
      />
    </template>

    <v-radio-group
      v-model="body.luovutuksenKohde"
      label="Luovutuksen kohde"
    >
      <v-radio
        v-for="(n, index) in luovutuksenKohdeOptions"
        :key="index"
        :label="n.text"
        :value="n.value"
        :disabled="!n.supported"
      />
    </v-radio-group>

    <v-text-field
      v-if="body.sopimussakkoPurkamisestaJosKauppahintaaEiMaksetaErapaivana"
      v-model="sakkoInEuros"
      label="Sopimussakko"
      hint="jos kauppahintaa ei makseta eräpäivänä"
      append-icon="euro_symbol"
      type="number"
      persistent-hint
      @input="body.sopimussakkoPurkamisestaJosKauppahintaaEiMaksetaErapaivana
        .amountInCents = Math.round(sakkoInEuros * 100)"
      @change="updateConfig()"
    />

    <v-radio-group
      v-model="body.buyersMortgageStatus"
      label="Rahoitus"
      class="mb-4"
      hide-details
      @change="updateConfig()"
    >
      <v-radio
        v-for="(n, index) in buyersMortgageStatuses"
        :key="index"
        :label="n.text"
        :value="n.value"
      />
    </v-radio-group>

    <v-alert
      v-if="body.buyersMortgageStatus === 'NO_MORTGAGE'"
      type="info"
      dense
      class="mt-2 caption"
      text
    >
      Olet valinnut, että yhdellekään ostajalle ei tule rahoitusta pankista.
      Käynnistäessäsi kaupan vahvistat, että noudatat voimassa olevia rahanpesun
      ja terrorismin rahoituksen estämisen lakeja sekä kiinteistönvälitysalan
      ohjeistuksia ja olet toteuttanut tarvittavat menettelyt varojen alkuperän
      selvittämiseksi ja asiakkaiden tuntemiseksi taataksesi asuntokaupan
      lainmukaisuuden ja turvallisuuden.
    </v-alert>
  </div>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    sakkoInEuros: 0,
    buyersMortgageStatuses: [
      {
        text: 'Kohde on menossa lainan vakuudeksi',
        value: 'MORTGAGE',
      },
      {
        text: 'Yhdelläkään ostajalla ei ole lainaa',
        value: 'NO_MORTGAGE',
      },
    ],
  }),
  computed: {
    luovutuskirjanTyyppiOptions() {
      if (this.config.data && this.config.data.options.luovutuskirjanTyyppi) {
        return this.config.data.options.luovutuskirjanTyyppi.values
          .map(item => ({
            text: item.displayText.fin,
            value: item.value,
            supported: item.supported,
          }));
      }
      return [];
    },

    luovutuksenKohdeOptions() {
      if (this.config.data && this.config.data.options.luovutuksenKohde) {
        return this.config.data.options.luovutuksenKohde.values
          .map(item => ({
            text: item.displayText.fin,
            value: item.value,
            supported: item.supported,
          }));
      }
      return [];
    },

    kayttotarkoitusOptions() {
      if (this.config.data && this.config.data.options.kayttotarkoitus) {
        return this.config.data.options.kayttotarkoitus.values
          .map(item => ({
            text: item.displayText.fin,
            value: item.value,
            supported: item.supported,
          }));
      }
      return [];
    },

    rakennustiedotOptions() {
      if (this.config.data && this.config.data.options.rakennustiedot) {
        return this.config.data.options.rakennustiedot.values
          .map(item => ({
            text: item.displayText.fin,
            value: item.value,
            supported: item.supported,
          }));
      }
      return [];
    },

    kaavatiedotOptions() {
      if (this.config.data && this.config.data.options.kaavatiedot) {
        return this.config.data.options.kaavatiedot.values
          .map(item => ({
            text: item.displayText.fin,
            value: item.value,
            supported: item.supported,
          }));
      }
      return [];
    },
  },
  watch: {
    body: {
      handler() {
        this.sakkoInEuros = this
          .body?.sopimussakkoPurkamisestaJosKauppahintaaEiMaksetaErapaivana?.amountInCents / 100;
      },
      deep: true,
    },
  },
  methods: {
    updateConfig() {
      this.$bus.$emit('GET_DIAS_CONFIG');
    },
  },
};
</script>
